<template>
  <b-row :class="{'is-invalid': !valid}">
    <b-col sm="5" class="form-label">
      <i class="fa fax fa-calendar-check"></i>
      <label>Geboortedatum*</label>
    </b-col>
    <b-col sm="6">
      <b-row class="date-wrap">
        <b-form-select
                class="col-3 day-input"
                v-model="day"
                :options="formData.days"
        />
        <b-form-select
                class="col-5"
                v-model="month"
                :options="formData.months"
        />
        <b-form-select
                class="col-4"
                v-model="year"
                :options="getYears(minAge, 100)"
        />
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { getDays, getMonths, getYears } from '@/_helpers'

export default {
  props: {
    value: {
      type: String,
    },
    valid: {
      type: Boolean,
      default: true
    },
    minAge: {
      type: Number,
      default: 18,
    }
  },
  data() {
    return {
      day: '',
      month: '',
      year: '',

      formData: {
        days: getDays(),
        months: getMonths(),
      },
    };
  },
  methods: {
    getYears(minAge, count){
      return getYears(minAge, count)
    }
  },
  computed: {
    date: {
      get() {
        if (this.day !== '' && this.month !== '' && this.year !== '') {
          return `${this.year}-${this.month}-${this.day}`
        } else {
          return ''
        }
      },
      set(val) {
        let dateArray = val.split('-')
        if (val) {
          this.day = parseInt(dateArray[2])
          this.month = parseInt(dateArray[1])
          this.year = parseInt(dateArray[0])
        }
      },
    },
  },
  created() {
    this.date = this.value;
  },
  watch: {
    date() {
      if (this.date) {
        this.$emit('input', this.date)
      }
    },
    value(){
      let dateArray = this.value.split('-')
      if (this.value) {
        this.day = parseInt(dateArray[2])
        this.month = parseInt(dateArray[1])
        this.year = parseInt(dateArray[0])
      }
    }
  },
}
</script>